export default {
    nl: {
        intro: {
            subtitle: 'Native apps',
            title: 'Op alle platforms draaien.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/native-apps/hero.jpg',
        },
        type: 'Native apps',
        title: 'Native apps voor naadloze ervaringen voor iOS & Android',
        description:
            'Ontdek de kracht van native apps. Optimaliseer voor prestaties, functionaliteit & gebruikerservaring op iOS en Android.',
        content: [
            {
                type: 'text',
                title: 'Native apps',
                content: `
                    Native apps zijn niet meer weg te denken uit ons dagelijkse leven. Denk aan voorbeelden zoals WhatsApp of Spotify. WhatsApp is de go-to communicatietool en stelt ons in staat om dagelijks in contact te blijven met dierbaren, zakenpartners en iedereen daartussenin. Aan de andere kant verrijkt Spotify ons leven als muzikale metgezel door het verzorgen van de perfecte soundtrack voor elk moment.
                    <br><br>
                    Native apps bieden gebruikers namelijk een sluitende ervaring, waarbij ze optimaal gebruik kunnen maken van de functies en mogelijkheden van hun apparaten. De developers bij 23G zijn daarom een groot voorstander van native apps. Wij geloven dat native apps dé manier zijn om zowel gebruikers als bedrijven naar een hoger niveau te tillen.
                `,
            },
            {
                type: 'images',
                images: ['https://23g-website.s3.eu-central-1.amazonaws.com/services/apps.webp'],
            },
            {
                type: 'text',
                title: 'Waarom Native?',
                content: `
                    Wat maakt native apps zo speciaal? Het geheim zit in de directe communicatie met het besturingssysteem van zowel iOS als Android apparaten. Dit geeft onze ontwikkelaars de mogelijkheid om de volledige functionaliteit te benutten. Hierdoor maken we apps die optimaal gebruikmaken van de mogelijkheden van de apparaten, wat resulteert in rijke, interactieve en persoonlijke ervaringen voor de gebruikers.
                    <br><br>
                    Dankzij JavaScript draaien de apps soepel en razendsnel, met verbluffende reactietijd en micro-animaties. Wanneer je overweegt om je UI/UX-design te verbeteren, zijn native apps dus een must. Ook offline bieden veel native apps hun functionaliteit, zodat gebruikers toegang blijven behouden tot belangrijke functies, zelfs zonder internetverbinding.
                    <br><br>
                    We zijn grote fans van native apps vanwege hun unieke eigenschappen. Ze hebben het beste van drie werelden: functionaliteit, visuele aantrekkingskracht en gebruiksvriendelijkheid. Ze creëren een gebruikerservaring die de verwachtingen van je eindgebruikers niet alleen tegemoet komt, maar ook overtreft.
                `,
            },
            {
                type: 'quote',
                content: 'Maatwerk in elke swipe - dat is wat native  apps bieden.',
            },
            {
                type: 'text',
                title: 'Onze werkwijze voor native apps',
                content: `
                    Bij 23G werken we met React Native. Dit open-source framework voor mobiele app-ontwikkeling is oorspronkelijk ontwikkeld door Facebook. Hiermee bouwen onze ontwikkelaars mobiele apps voor meerdere platformen, zoals iOS en Android. Dit doen we vanuit één uniforme codebase, geschreven in JavaScript en React.
                    <br><br>
                    De magie zit in de gedeelde code, waardoor we tijd besparen en ons kunnen concentreren op het verfijnen van de ervaring op beide platforms. Het framework maakt gebruik van native componenten en modules, waardoor de apps ogen en aanvoelen alsof ze zijn gebouwd met behulp van traditionele ontwikkelingstools.
                    <br><br>
                    Naast app-ontwikkeling bieden we een breed scala aan services, waaronder front-end development en back-end development. Met onze brede expertise in technologieën ben je verzekerd van een geïntegreerde digitale oplossing.
                `,
            },
            {
                type: 'case',
                case: 'rembrandt',
            },
        ],
        related_services: ['front-end-development', 'strategy-session', 'back-end-development'],
        contact: {
            title: '',
            employee: 'tobias',
        },
    },
    en: {},
};
